const modulo_productos = {
	strict: false,

  state: {
     productos: [],
     producto_precios: []
  },	

	getters: {
		get_productos: state => state.productos,
		get_producto_precios: state => state.producto_precios
	},

	mutations: {
		set_productos: (state, lista_productos) => state.productos = lista_productos,
		set_producto_precios: (state, precios) => state.producto_precios = precios
	},

	actions: {
		setProductos: (context, lista_productos) => context.commit('set_productos', lista_productos),
		getProductoPrecios: async (context, { idProducto, idProyecto }) => {
			try {
				const response = await axios.get(`api/producto-precios/${idProducto}`, {
					params: {
						id_proyecto: idProyecto
					}
				});
				context.commit('set_producto_precios', response.data);
				return response.data;
			} catch (error) {
				console.error('Error al obtener precios del producto:', error);
				return [];
			}
		},
		saveProductoPrecios: async (context, { producto_precio, idProyecto }) => {
			try {
				const response = await axios.post('api/producto-precios', {
					...producto_precio,
					id_proyecto: idProyecto
				});
				context.commit('set_producto_precios', response.data);
				return response.data;
			} catch (error) {
				console.error('Error al guardar precio del producto:', error);
				throw error;
			}
		},
		deleteProductoPrecios: async (context, { idProductoPrecio, idProyecto }) => {
			try {

				await axios.delete(`api/producto-precios/${idProductoPrecio}`, {
					params: { id_proyecto: idProyecto }
				});
				// context.commit('set_producto_precios', response.data);
				// return response.data;
			} catch (error) {
				console.error('Error al eliminar precio del producto:', error);
				throw error;
			}
		}
	}
}

export default modulo_productos;
